import $ from 'jquery';
import WOW from 'wowjs';

$(() => {
	const wow = new WOW.WOW({
		mobile: false
	});
	wow.init();

	$('.tooltip').hover(function() {
		const text = $(this).children('.tooltip__text');
		const body = $(this).children('.tooltip__body');
		const info = $('.info');
		const scrollTop = $(window).scrollTop();
		const top = text.offset().top - scrollTop + text.height();
		const left = $(window).innerWidth() <= 768 ? '50%' : text.offset().left - (info.width() / 2);
		info.html(body.html());
		info.css({
			top,
			left
		});
		info.addClass('is-active');
	}, function(e) {
		const info = $('.info');
		setTimeout(() => {
			info.removeClass('is-active');
		}, 500);
	});

	//menu
	var m2 = $('.header__menu');
	var darker = $('.menu__darker');
	var open_button = $('.header__menu-button');
	var close_button = $('.menu__close');
	var menu_item = $('.menu__item');

	function offMenu() {
	m2.hide();
	darker.off('click');
	$('body').css("overflow","auto");
	}
	function onMenu() {
	m2.show();
	$('body').css("overflow","hidden");
	darker.click(offMenu);
	}

	open_button.click(function() {onMenu();});
	close_button.click(function() {offMenu();});

	menu_item.click(function() {
	let classes = ['what-is-it','how-is-transmitted','symptoms','diagnostics','what-to-do','treatment','life'];
	offMenu();
	//scrollToItem($('.'+classes[$(this).index()-1]),0);
	let item = $('.'+classes[$(this).index()-1]);
	inScroll = true;
	$('html, body').animate({"scrollTop": item.offset().top},300,function () {
		if ($('body').hasClass('mobile')) {
		//console.log('qqq');
		menu.addClass(hideClass);
		setTimeout(function () {
			inScroll = false;
		},50);
		}
	});
	});

	//Hide menu on scroll
	var inScroll = false;
	var lastScrollTop = 0;
	var menuClass = '.header';
	var menuItemClass = '.menu__item';
	var hideClass = 'menu-hidden';
	var menu = $(menuClass);

	$(window).scroll(function(event){
	var scroollTop = $(this).scrollTop();
	if (!inScroll) {
		var menuHeight = $(menuClass).outerHeight();

		if (scroollTop > lastScrollTop && scroollTop > menuHeight)
		menu.addClass(hideClass);
		else
		if(scroollTop + $(window).height() < $(document).height())
		menu.removeClass(hideClass);
		//console.log('qqq1');
	}
	lastScrollTop = scroollTop;
	});

	$(menuItemClass).click(function () {
	setTimeout(function () { menu.addClass(hideClass); }, 100);
	});
});



// WEBPACK FOOTER //
// ./app/scripts/app.js